.notificationStyle {
  display: flex;
  gap: 8px;
  width: 100%;
  height: 100%;
  padding: 8px;
  border-radius: 6px;
  border-left: solid 6px;
  font-weight: 400;
  font-size: 16px;
}

.notificationVariantStyle--warning {
  background-color: var(--tractie-color-background-warning-subtle);
  border-left-color: var(--tractie-color-border-warning);
  color: var(--tractie-color-content-default);
}

.notificationVariantStyle--error {
  background-color: var(--tractie-color-background-error-subtle);
  border-left-color: var(--tractie-color-border-error);
  color: var(--tractie-color-content-default);
}

.notificationVariantStyle--info {
  background-color: var(--tractie-color-background-info-subtle);
  border-left-color: var(--tractie-color-border-info);
  color: var(--tractie-color-content-default);
}

.notificationVariantStyle--success {
  background-color: var(--tractie-color-background-success-subtle);
  border-left-color: var(--tractie-color-border-success);
  color: var(--tractie-color-content-default);
}
